import axios from 'axios';
// https://api.truvey.in/api
// Base configuration for axios
const apiClient = axios.create({
  //  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.truvey.in/api', // Replace with your API base URL
  // baseURL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:44346/api', // Replace with your API base URL
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.xprssurvey.com/api', // Replace with your API base URL
   // baseURL: process.env.REACT_APP_API_BASE_URL || 'https://xprssurveyapi.demoo4s.com/api', // Replace with your API base URL
  
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the JWT token in the headers
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Retrieve token from local storage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const ReportService = {
    ExportSurveyReport: async (Token, SurveyUID) => {
        try {
          const response = await apiClient.post('/Survey/ExportSurveyResponseData',
            { Token, SurveyUID }
            , {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          return response.data;
        } catch (error) {
          console.error("Error fetching permission data:", error);
        }
      },
      GetSurveyReport: async (Token, SurveyUID) => {
        try {
          const response = await apiClient.post('/Survey/ResponseBreakdownReport',
            { Token, SurveyUID }
            , {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          return response.data;
        } catch (error) {
          console.error("Error fetching permission data:", error);
        }
      },
      GetBuildAnalysisQuestions: async (Token, SurveyUID) => {
        try {
          const response = await apiClient.post('/Survey/GetBuildAnalysisQuestions',
            { Token, SurveyUID }
            , {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          return response.data;
        } catch (error) {
          console.error("Error fetching permission data:", error);
        }
      },
      UpdateBuildAnalysisQuestions: async (Token, SurveyUID,QuestionData) => {
        try {
          const response = await apiClient.post('/Survey/UpdateBuildAnalysisQuestions',
            { Token, SurveyUID,QuestionData }
            , {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          return response.data;
        } catch (error) {
          console.error("Error fetching permission data:", error);
        }
      },
}

export default ReportService;
